import { Euler, Quaternion } from "three"

export default function mujocoQuatToEuler(mujocoQuat: [number, number, number, number]) {
    return new Euler().setFromQuaternion(
        new Quaternion(
            mujocoQuat[1],
            mujocoQuat[2],
            mujocoQuat[3],
            mujocoQuat[0]
        ).normalize()
    );
}